import {AuthorizationFetcher, utils} from '@wallaby-ui/core';

/** @deprecated */
const AutocompleteFetcher = {
  get(requestUrl, params, byPrefixMethod) {
    const paramString = `prefix=${encodeURIComponent(params.prefix)}`;

    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}/${encodeURIComponent(
        params.type
      )}/${byPrefixMethod}?${paramString}`,
      {method: 'get'},
      {'Content-Type': 'application/json'}
    )
      .then(utils.FetcherUtils.processJsonResponse)
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },

  getLabels(requestUrl, params, byPathsMethod) {
    const paramString = `paths=${encodeURIComponent(
      params.paths
    )}&type=${encodeURIComponent(params.type)}`;

    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}/${encodeURIComponent(
        params.type
      )}/${byPathsMethod}?${paramString}`,
      {method: 'get'},
      {'Content-Type': 'application/json'}
    )
      .then(utils.FetcherUtils.processJsonResponse)
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },
};

export default AutocompleteFetcher;
